import { render, staticRenderFns } from "./QuoteBuilderItemsView.vue?vue&type=template&id=88e085ba"
import script from "./QuoteBuilderItemsView.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderItemsView.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderItemsView.vue?vue&type=style&index=0&id=88e085ba&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88e085ba')) {
      api.createRecord('88e085ba', component.options)
    } else {
      api.reload('88e085ba', component.options)
    }
    module.hot.accept("./QuoteBuilderItemsView.vue?vue&type=template&id=88e085ba", function () {
      api.rerender('88e085ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/QuoteBuilderItemsView.vue"
export default component.exports